import numeral from 'numeral';

export const BITCOIN_DECIMAL_PLACES_FORMAT = '0.00000';
export const DEFAULT_DECIMAL_FORMAT = '0.00';

export function roundOffAmount(amt) {
  return parseFloat((Math.abs(amt)).toFixed(2));
}

/**
 * This function exists coz of a bug on numeraljs
 * See: https://github.com/adamwdraper/Numeral-js/issues/563
 * 
 * Use numbrojs on future instead.
 * 
 * @param {Numeral} numeral 
 * @param {string} format 
 */
export function format(numeralObject, numberFormat) {
  return isNaN(numeralObject.format(numberFormat))
    ? numeralObject._input
    : numeralObject.format(numberFormat)
  ;
}


// WEBPACK FOOTER //
// ./client/app/shared/utils/number.utils.js